export enum SearchTabs {
  PRODUCTS = "products",
  ARTICLES = "articles",
}
